const INSTRUCTION_TYPES = {
  LOGIN: 'login',
  REGISTER: 'register',
}

export default INSTRUCTION_TYPES
